import { createModel } from '@rematch/core';
import { bryt } from '../../http';
import { invalidBlock } from '../../app.config';

export const blocks = createModel()({
  name: 'blocks',
  state: {
    loading: false,
    blocks: [],
    lastFetched: 0,
    blockHeight: 0,
    pages: 0,
    blocksData: [],
  },
  reducers: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setBlocks(state, payload) {
      state.blocks = payload;
    },
    setLastFetch(state, payload) {
      state.lastFetched = payload;
    },
    setBlockHeight(state, payload) {
      state.blockHeight = payload;
    },
    setPages(state, payload) {
      state.pages = payload;
    },
    setBlocksData(state, payload) {
      state.blocksData = payload;
    },
  },
  effects: dispatch => ({
    // async handleGetAllBlocks(_, state) {
    //   try {
    //     const { lastFetched } = state.blocks;
    //     const blocks = [];
    //     dispatch.blocks.setLoading(true);
    //     var last = lastFetched;
    //     const res = await bryt.getBlockHeight();
    //     const height = res.result.height;

    //     if (height > last) {
    //       console.log(`Fetching from ${last} to ${height}`);
    //       await sleep();
    //       for (let i = last; i < height; i++) {
    //         try {
    //           const res = await bryt.getBlockByBLockNumber(i.toString());
    //           const block = res.result;
    //           blocks.push(block);
    //         } catch (err) {
    //           console.log('Error fetching block:', i);
    //           const b = { ...invalidBlock }; // Ensure a new object is created for each invalid block
    //           b.block_number = i.toString(); // Set the block number correctly
    //           blocks.push(b);
    //         }
    //       }
    //       dispatch.blocks.setBlocks([
    //         ...blocks.reverse(),
    //         ...state.blocks.blocks,
    //       ]);
    //       dispatch.blocks.setLastFetch(height);
    //     }
    //   } catch (err) {
    //     console.log(err.message);
    //   } finally {
    //     dispatch.blocks.setLoading(false);
    //   }
    // },

    async handleGetAllBlocks(_, state) {
      try {
        dispatch.blocks.setLoading(true);
        const res = await bryt.getBlockHeight();
        const height = res.result.height;
        const pages = Math.ceil(height / 10);
        dispatch.blocks.setPages(pages);
        let startIndex = 0;
        if (height > 10) {
          startIndex = height - 10;
        }

        const blocks = [];

        for (let i = startIndex; i < height; i++) {
          try {
            const res = await bryt.getBlockByBLockNumber(i.toString());
            const block = res.result;
            blocks.push(block);
          } catch (err) {
            console.log('Error fetching block:', i);
            const b = { ...invalidBlock };
            b.block_number = i.toString();
            blocks.push(b);
          }
        }
        dispatch.blocks.setBlocks([...blocks.reverse()]);
      } catch (err) {
        console.log(err.message);
      } finally {
        dispatch.blocks.setLoading(false);
      }
    },
    async getBlockWithPagination(page) {
      try {
        dispatch.blocks.setLoading(true);
        const res = await bryt.getBlockHeight();
        const height = res.result.height;
        const pages = Math.ceil(height / 10);
        dispatch.blocks.setPages(pages);
        let startIndex = (page - 1) * 10;
        const blocks = [];

        for (let i = startIndex; i < startIndex + 10; i++) {
          try {
            if (i >= height) break;
            const res = await bryt.getBlockByBLockNumber(i.toString());
            const block = res.result;
            blocks.push(block);
          } catch (err) {
            console.log('Error fetching block:', i);
            const b = { ...invalidBlock };
            b.block_number = i.toString();
            blocks.push(b);
          }
        }
        console.log(blocks);
        dispatch.blocks.setBlocksData(blocks);
      } catch (err) {
        console.log(err.message);
      } finally {
        dispatch.blocks.setLoading(false);
      }
    },
  }),
});
